import { NgModule } from '@angular/core';

import { ProductComponent } from "./product.component";
import { PackageComponent } from '../package/package.component';
import { ProductRoutingModule } from "./product-routing.module";

import { SharedModule } from "../../shared/shared.module";

import {VgCoreModule} from 'videogular2/core';
import {VgControlsModule} from 'videogular2/controls';
import {VgOverlayPlayModule} from 'videogular2/overlay-play';
import {VgBufferingModule} from 'videogular2/buffering';

@NgModule({
    imports: [
        SharedModule,
        ProductRoutingModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule
    ],
    declarations: [
        ProductComponent,
        PackageComponent
    ]
})

export class ProductModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/product/product.module.ts